import { createStore } from "zustand";
import { immer } from "zustand/middleware/immer";
import { get as getLodash, set as setLodash, assign } from "lodash-es";
import utils from "./utils";

// 类型定义
interface LocalStoreState {
  values: Record<string, any>;
  isInitialized: boolean;
  setItem: (key: string, value: any) => void;
  assignItem: (key: string, value: any) => void;
  setItems: (values: Record<string, any>) => void;
  deleteItem: (key: string) => void;
  initialize: () => void;
}

const store = createStore<LocalStoreState>()(
  immer(set => ({
    values: {},
    isInitialized: false,
    initialize: () =>
      set(state => {
        if (!state.isInitialized) {
          try {
            const savedValues = utils.getObject("myconfig");
            state.values = savedValues || {};
            state.isInitialized = true;
          } catch (error) {
            console.warn("Failed to initialize localstore:", error);
            state.values = {};
            state.isInitialized = true;
          }
        }
      }),
    setItem: (key: string, value: any) =>
      set(state => {
        if (!state.isInitialized) {
          state.initialize();
        }
        setLodash(state.values, key, value);
        utils.setObject("myconfig", state.values);
      }),
    assignItem: (key: string, value: any) =>
      set(state => {
        if (!state.isInitialized) {
          state.initialize();
        }
        const oldValue = getLodash(state.values, key);
        const newValue = assign(oldValue, value);
        setLodash(state.values, key, newValue);
        utils.setObject("myconfig", state.values);
      }),
    setItems: (values: Record<string, any>) => {
      set(state => {
        if (!state.isInitialized) {
          state.initialize();
        }
        assign(state.values, values);
        utils.setObject("myconfig", state.values);
      });
    },
    deleteItem: (key: string) =>
      set(state => {
        if (!state.isInitialized) {
          state.initialize();
        }
        delete state.values[key];
        utils.setObject("myconfig", state.values);
      }),
  }))
);

// 导出 store 实例供 hooks 使用
export { store };

export const setLocalStoreValue = (key: string, value: any) => {
  store.getState().setItem(key, value);
};
